import * as type from './type'
import { uploadCSV } from '../../../api'
import { getFoilList } from '../info-table/action'

export const uploadCSVRequest = () => ({
    type: type.UPLOAD_CSV_REQUEST,
})

export const uploadCSVError = (error) => {
    return {
        type: type.UPLOAD_CSV_ERROR,
        payload: {
            error,
        },
    }
}

export const uploadCSVSuccess = () => ({
    type: type.UPLOAD_CSV_SUCCESS,
})

export const uploadFoilCSV = (file) => (dispatch) => {
    dispatch(uploadCSVRequest())

    const data = new FormData()
    data.append('file', file)

    uploadCSV(data).then(response => {
        return response.json().then(data => {
            if (response.ok) {
                dispatch(uploadCSVSuccess())
                dispatch(getFoilList())
            } else {
                dispatch(uploadCSVError(data))
            }
        })
    }).catch(() => {
        dispatch(uploadCSVError({ error: 'Server error' }))
    })
}



// WEBPACK FOOTER //
// ./src/modules/foil/state/overview/csv-upload/action.js